import React from 'react';

type Props = {
    children?: React.ReactNode | React.ReactNode[];
};

export const TabContentTableWrapper: React.FC<Props> = ({ children }) => {
    return <div className="flex w-full flex-col">{children}</div>;
};
